(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function ($) {
 
function revealSlide(){
	$('.et_pb_module.et_pb_slider').removeClass("et_pb_pause_slider");
	$('.et_pb_module.et_pb_slider').fadeIn();
}
function startLoop(){
	setInterval(triggerSVG, 6000, true);// must be the same as the Divi slide speed
}                       

$("#slider").append('Stop');
  
  	$(document).ready(function(){
  	  
  	  //reveal the slide ~ after the logo animation is completed
	  setTimeout(revealSlide, 0);// start the slider3500
	  setTimeout(startLoop, 2500);

  	  //pause slides
  	  $('.et_pb_module.et_pb_slider').addClass("et_pb_pause_slider");
  	  $('.et_pb_module.et_pb_slider').hide();

  	  //Randomize divi sliders
	  var item = document.querySelector('.et_pb_slider .et_pb_slides');

	  if(item!=null){
	    for (var i = item.children.length; i >= 0; i--) {
	      item.appendChild(item.children[Math.random() * i | 0]);
	    }
	  }
	});

})(jQuery);

document.addEventListener('DOMContentLoaded', triggerSVG); //iOs doesn't support window.addEventListener("load")


function triggerSVG(restart) {

   // Get the Object by ID
	var svg = document.getElementById("svgObject");


	//wait for the SVG to be fully loaded
	svg.addEventListener('load', () => {
	  console.log('SVG loaded.');
	  animateSVG(svg);
	});

	if (restart == true){
		console.log('restart');
		animateSVG(svg);
	}

	function animateSVG(svg) {

    	// Get the SVG document inside the Object tag
		var svgDoc = svg.contentDocument;

		var oldsvg = svgDoc.getElementById("ee6oex5ao2ub1");
		var newsvg = oldsvg.cloneNode(true);

		//clone svg to restart it
		oldsvg.parentNode.replaceChild(newsvg, oldsvg);
		if (restart == true){
			//reset all class before restarting animation
			svgDoc.getElementById("ee6oex5ao2ub1").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub1").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub1").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub2").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub2").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub2").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub3_to").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub3_to").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub3_to").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub3").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub3").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub3").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub4").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub4").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub4").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub15_to").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub15_to").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub15_to").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub15_ts").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub15_ts").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub15_ts").offsetWidth;

			svgDoc.getElementById("ee6oex5ao2ub15_in").classList.remove("trigger");
			svgDoc.getElementById("ee6oex5ao2ub15_in").setAttribute("class", "");
			void svgDoc.getElementById("ee6oex5ao2ub15_in").offsetWidth;
			
			
		}

		svgDoc.getElementById("ee6oex5ao2ub1").classList.remove("run-animation");
		svgDoc.getElementById("ee6oex5ao2ub1").setAttribute("class", "");

			//if we restart we don't need the fade in
			if (restart != true){
				svgDoc.getElementById("ee6oex5ao2ub2").setAttribute("class", "trigger");
				svgDoc.getElementById("ee6oex5ao2ub4").setAttribute("class", "trigger");
				svgDoc.getElementById("ee6oex5ao2ub15_in").setAttribute("class", "trigger");
			} else {
				svgDoc.getElementById("ee6oex5ao2ub2").setAttribute("class", "triggered");
				svgDoc.getElementById("ee6oex5ao2ub4").setAttribute("class", "triggered");
				svgDoc.getElementById("ee6oex5ao2ub15_in").setAttribute("class", "triggered");
			}

			svgDoc.getElementById("ee6oex5ao2ub1").setAttribute("class", "trigger run-animation");
			svgDoc.getElementById("ee6oex5ao2ub3_to").setAttribute("class", "trigger");
			svgDoc.getElementById("ee6oex5ao2ub3").setAttribute("class", "trigger");
			svgDoc.getElementById("ee6oex5ao2ub15_to").setAttribute("class", "trigger");
			svgDoc.getElementById("ee6oex5ao2ub15_ts").setAttribute("class", "trigger");

		
		//svgDoc.getElementById("ee6oex5ao2ub1").setAttribute("class", "run-animation");
		
		// Get one of the SVG items by ID;
		var svgItem = svgDoc.getElementById("ee6oex5ao2ub3");

		svgItem.textContent = "0%";// set the progress bar to 0%
		myLoop(100, svgItem);// call the function to run count down
	}
	
	// count up to 100%
	function myLoop (i, svgItem) {
	   setTimeout(function () {
		  svgItem.textContent = 101-i+"%";           
		  if (--i) myLoop(i, svgItem);      //  decrement i and call myLoop again if i > 0
	   }, 35);
	}
}


},{}]},{},[1]);
